export default {"src":"/_next/static/media/trophy.23ca7ba0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};